import { Outlet, useMatchRoute, useRouter } from "@tanstack/react-router";
import { useIsFirstGigPost } from "api/queries/locations";
import { LoaderLogo } from "components/Loader/logo";
import { MaintenanceModeDialog, maintenanceRoutes } from "components/MaintenanceModeDialog";
import { useFirstPostRedirect } from "domains/aiChat/hooks/useFirstPostRedirect";
import { AgentChatShell } from "layouts/BaseLayout/AgentChatShell";
import { SuperAdminPanel } from "layouts/SuperAdminPanel";
import { useFeatureFlag } from "providers/LaunchDarkly";
import React from "react";
import { useAuthenticatedStateSetup } from "services/globalState";
import { useActiveLocationId } from "services/locationOrgContext";

export const SignedUpGuard: React.FC = () => {
  const router = useRouter();
  const matchRoute = useMatchRoute();

  const maintenanceModeEnabled =
    useFeatureFlag("maintenance-mode") && maintenanceRoutes.some((r) => !!matchRoute({ to: r, fuzzy: true }));

  const locationSetupLoading = useAuthenticatedStateSetup();
  const [activeLocationId] = useActiveLocationId();

  const isInitialGigPost = useIsFirstGigPost();
  useFirstPostRedirect(isInitialGigPost, activeLocationId);

  if (locationSetupLoading) return <LoaderLogo />;

  return (
    <>
      <MaintenanceModeDialog open={maintenanceModeEnabled} onBack={() => router.history.back()} />
      <AgentChatShell>
        <SuperAdminPanel />
        <Outlet />
      </AgentChatShell>
    </>
  );
};
